export const maskApiKey = (apiKey?: string): string => {
  if (!apiKey) {
    return "";
  }
  if (apiKey.length <= 4) {
    return "••••";
  }
  const hiddenLength = Math.min(apiKey.length - 4, 16);
  return `${"•".repeat(hiddenLength)}${apiKey.slice(-4)}`;
};

export const formatImportFilterModeLabel = (
  mode: "union" | "intersection" | undefined
): string =>
  mode === "union"
    ? "Match donors with selected flags OR donor types"
    : "Match donors with selected flags AND donor types";

export const formatImportFilterModeTooltip = (
  mode: "union" | "intersection" | undefined
): string =>
  mode === "union"
    ? "OR: import donors that match any selected flag or any selected donor type. OR will import all donors."
    : "AND: import donors that match both a selected segment flag and a selected donor type. AND will import only donors that match.";
